import { ApiService } from './ApiService';

export const ApiUser = {
  userList: (roleId?: string, search?: string, institution?: string, acad?: string, program?: string, faculty?: string, status?: string, take?: number, page?: number) => `${ApiService.user}?roleId=${roleId}&search=${search}&institution=${institution}&acad=${acad}&program=${program}&faculty=${faculty}&status=${status}&take=${take}&page=${page}`,
  userDetail: (userId: string) => `${ApiService.user}/details?userId=${userId}`,
  verifyUser: `${ApiService.user}/update`,
  verifyBulkUsers: `${ApiService.user}/bulk-verification`,
  userRoleList: `${ApiService.user}/role`,
};
